import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const region = {

  getClientId () {
    return store.getters['Client/clientId']
  },
  getRegions () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/regions`)
  },
  getRegion (regionId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/regions/` + regionId)
  },
  getRegionDesks (fixedAsset){
    return Axios.get(`api/${strings.apiVersion.admin}/regions/${fixedAsset}/desks`)
  },
  addRegion (region) {
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/regions`, region)
  },
  editRegion (region) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/regions/${region.id}`, {
      fixedAsset: region.fixedAsset,
      active: region.active
    })
  },
  deleteRegion (id) {
    return Axios.delete(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/regions/` + id)
  }
}

export default region
